"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ComplaintTypeEnum = void 0;
/** Тип жалобы */
var ComplaintTypeEnum;
(function (ComplaintTypeEnum) {
  /** Жалоба на урок */
  ComplaintTypeEnum[ComplaintTypeEnum["ContentComplaint"] = 1] = "ContentComplaint";
  /** Жалоба на пользователя */
  ComplaintTypeEnum[ComplaintTypeEnum["UserComplaint"] = 2] = "UserComplaint";
  /** Жалоба на митинг */
  ComplaintTypeEnum[ComplaintTypeEnum["MeetingComplaint"] = 3] = "MeetingComplaint";
  /** Жалоба на коллекцию */
  ComplaintTypeEnum[ComplaintTypeEnum["CollectionComplaint"] = 4] = "CollectionComplaint";
  /** Жалоба на школу */
  ComplaintTypeEnum[ComplaintTypeEnum["SchoolComplaint"] = 5] = "SchoolComplaint";
  /** Жалоба на услугу */
  ComplaintTypeEnum[ComplaintTypeEnum["UserServiceComplaint"] = 6] = "UserServiceComplaint";
})(ComplaintTypeEnum = exports.ComplaintTypeEnum || (exports.ComplaintTypeEnum = {}));
